import { PackagesApi } from '../../api'
import { setPackages } from '../setPackages'
import { setDiscounts } from '../setDiscounts'

export const fetchPackages = userType => {
  return async (dispatch) => {
    const api = new PackagesApi()
    const {packages, discounts} = await api.getPackages(userType)
    dispatch(setPackages(packages))
    dispatch(setDiscounts(discounts))
  }
}
